// One opening per conversation, including concurrent callers and session changes.
export function createStudioSession(api, onConversation, onOpening) {
  let generation = 0, conversation = null, pending = null;
  const end = (c) => c && api.post(`/studio/conversations/${c.id}/end`).catch(() => {});
  return {
    async begin({ entry, mode, channel, commonMode = 'published' }) {
      if (conversation?.opening) return conversation;
      if (pending) return pending;
      const ticket = generation;
      const task = (async () => {
        const c = conversation || (await api.post('/studio/conversations', { entry_agent_id: entry, mode, channel, common_mode: commonMode })).data;
        if (ticket !== generation) { end(c); throw new Error('Session modifiée'); }
        conversation = c;
        const opening = (await api.post(`/studio/conversations/${c.id}/opening`, { channel })).data;
        if (ticket !== generation) { end(c); throw new Error('Session modifiée'); }
        conversation = { ...c, opening };
        onConversation(conversation);
        onOpening(opening);
        return conversation;
      })();
      pending = task;
      try { return await task; }
      finally { if (pending === task) pending = null; }
    },
    reset() {
      generation += 1;
      end(conversation);
      conversation = null;
      pending = null;
    },
    adopt(c) { generation += 1; conversation = { ...c, opening: true }; pending = null; },
    ticket() { return generation; },
    valid(ticket) { return ticket === generation; },
    isCurrent(id) { return conversation?.id === id; },
  };
}
